<template>
  <p class="text-xs italic text-center">
    <slot></slot>
  </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Informational-text-component',
});
</script>

<style lang="scss" scoped></style>
